import './App.css';
import { DinneyNavbar } from './components/navbar/DinneyNavbar';
import { Route, Routes } from 'react-router-dom';
import { Home } from './components/Home';
import { AuthenticationGuard } from './components/util/AuthenticationGuard ';
import { CustomersPage } from './components/customer/CustomersPage';
import { MealsPage } from './components/meal/MealsPage';
import { Container } from 'react-bootstrap';
import { AxiosProvider } from './config/axios-config';
import { ConfigProvider } from 'antd';
import locale from 'antd/locale/pl_PL'
import dayjs from 'dayjs';
import 'dayjs/locale/pl'
import { MealSelectionPage } from './components/mealselection/MealSelectionPage';
import { DinneyFooter } from './components/navbar/DinneyFooter';
import { ErrorPage } from './components/error/ErrorPage';
import { useAuth0 } from "@auth0/auth0-react";
import { CustomersForPaymentsPage } from './components/customerforpayments/CustomersForPaymentsPage';
import { DinneyAdminPage } from './components/dinneyadmin/DinneyAdminPage';
import {AccountPage} from "./components/account/AccountPage";
import {createContext, SetStateAction, useEffect, useState} from "react";
import {MenuWeekPage} from "./components/menu/week/MenuWeekPage";
import { MealsDailySummaryPage } from './components/mealsdailysummary/MealsDailySummaryPage';

export const UserContext = createContext({
  userCompanyName: '',
  setUserCompanyName: (value: SetStateAction<string>) =>{},
})
export const App = () => {

  dayjs.locale('pl')
  const {
      user,
  } = useAuth0();

  const [userCompanyName, setUserCompanyName] = useState<string>('')

  useEffect(() => {
    if (user != null) {
      setUserCompanyName(user.company_name)
    }
  }, [user]);
  return (
    <AxiosProvider>
      <ConfigProvider locale={locale}>
        <div className='content-container'>
        <UserContext.Provider value={{userCompanyName, setUserCompanyName}}>
        <DinneyNavbar />
        <Container fluid className='p-0 m-0'>
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />

          {user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE)
          && user?.email_verified &&
          <>
            <Route
            path="/meals"
            element={<Container fluid className='p-4'><AuthenticationGuard component={MealsPage} /></Container>}
          />
          <Route
            path="/customers"
            element={<Container fluid className='p-4'><AuthenticationGuard component={CustomersPage} /></Container>}
          />
          <Route
            path="/customersforpayments"
            element={<Container fluid className='p-4'><AuthenticationGuard component={CustomersForPaymentsPage} /></Container>}
          />
            <Route
                path="/mealsdailysummary"
                element={<Container fluid className='p-4'><AuthenticationGuard component={MealsDailySummaryPage} /></Container>}
            />
          </>
          }
            {(user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE)
                    || user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT) ) && user?.email_verified &&
                <Route
                    path="/mealselection"
                    element={<Container fluid className='p-4'><AuthenticationGuard component={MealSelectionPage} /></Container>}
                />
            }
          {(user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE)
              || user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_PARENT))
          && user?.email_verified &&
            <Route
                path="/menuweeks"
                element={<Container fluid className='p-4'><AuthenticationGuard component={MenuWeekPage} /></Container>}
            />
          }
          <Route
            path="/account"
            element={<Container fluid className='p-4'><AuthenticationGuard component={AccountPage} /></Container>}
          />
          {user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE_ADMIN) && user?.email_verified &&
          <>
            <Route
            path="/dinneyadmin"
            element={<Container fluid className='p-4'><AuthenticationGuard component={DinneyAdminPage} /></Container>}
          />
          </>
          }
          <Route
            path="/login"
            element={<Home />}
          />
          <Route
            path="*"
            element={<Container fluid className='p-4'><ErrorPage/></Container>}
          />
        </Routes>
        </Container>
        </UserContext.Provider>
        </div>
        <DinneyFooter />
      
      </ConfigProvider>
    </AxiosProvider>
  );
}
